export enum EImmediatelyOpenModalType {
  Creation = 'creation',
  Details = 'detail'
}

export type TImmediatelyOpenModalQueryParams = {
  modal: EImmediatelyOpenModalType;
  tab?: string;
  id?: string;
}